import { Component, Input, OnInit } from '@angular/core';
import {EquipamentoService} from 'src/app/services/equipamento.service';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import { Fornecedor } from 'src/app/model/Fornecedor';

@Component({
  selector: 'app-informacoes-da-fabricante',
  templateUrl: './informacoes-da-fabricante.component.html',
  styleUrls: ['./informacoes-da-fabricante.component.scss'],
  standalone: false
})
export class InformacoesDaFabricanteComponent implements OnInit {

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  listaFornecedores: Fornecedor[] = [];
  fornecedor: Fornecedor;
  
  constructor(private equipamentoService : EquipamentoService) { }

  ngOnInit(): void {
    this.equipamentoService.obterFornecedores(this.documentoPac.id).subscribe(
      (fornecedores) =>{
        this.listaFornecedores = fornecedores;
        if(this.listaFornecedores.length==1)
          this.fornecedor = this.listaFornecedores[0];
      },
      (error)=>{
        console.error(`Erro ao pesquisar lista de fornecedores: ${error}`);
      }
    );
  }

}
